import { TAG_TREES } from "utils";

export const ITEMS_PER_PAGE = 6;
export const TABS = ["news", "events"] as const;
export const MAPED_TABS = {
  fa: {
    [TABS[0]]: "اخبار",
    [TABS[1]]: "اعلانات",
  },
  en: {
    [TABS[0]]: "News",
    [TABS[1]]: "Events",
  },
} as const;

export const MAPED_TAG_TREES = {
  fa: {
    [TABS[0]]: TAG_TREES.FA.NEWS,
    [TABS[1]]: TAG_TREES.FA.EVENTS,
  },
  en: {
    [TABS[0]]: TAG_TREES.EN.NEWS,
    [TABS[1]]: TAG_TREES.EN.EVENTS,
  },
} as const;
